"use strict";

exports.__esModule = true;
exports.IconClickFallbackImage = void 0;
var _CreativeUtils = require("../Utils/CreativeUtils");
var _XmlValidation2 = require("../Parsers/XmlValidation");
var _StringUtils = require("../Utils/StringUtils");
var _Resource = require("./Resource");
var _VASTProperty = require("./VASTProperty");
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2020-2022 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */ // JsDoc/Typescript imports
/**
 * Represents an icon click fallback image object.
 *
 * Encapsulates the data from the `<IconClickFallbackImage>` element of a VAST document.<br/>
 * It is a graphic that is used when a target platform does not support HTML rendering: the information
 * is provided as an image instead.
 * 
 *  @hideconstructor
 */
var IconClickFallbackImage = exports.IconClickFallbackImage = /*#__PURE__*/function (_XmlValidation) {
  _inheritsLoose(IconClickFallbackImage, _XmlValidation);
  function IconClickFallbackImage(properties, altText, resource) {
    var _this;
    _this = _XmlValidation.call(this) || this;

    /** @private */
    _this.properties = properties ? properties : [];
    /** @private */
    _this.altText = altText;
    /** @private */
    _this.resource = resource;
    return _this;
  }

  /**
   * @return {string} the alternative text of the image, as a `string`
   */
  var _proto = IconClickFallbackImage.prototype;
  _proto.getAltText = function getAltText() {
    return this.altText;
  }

  /**
   * Returns the properties for the iconclick fallback image. The properties are represented as YOVASTProperty objects.
   * Possible properties are:
   * - width
   * - height
   * 
   * @return {VASTProperty[]} an array of {@link VASTProperty} objects for the image
   */;
  _proto.getProperties = function getProperties() {
    return Object.assign([], this.properties);
  }

  /**
   * Returns a named property for the iconclick fallback image if it exists. Possible properties are:
   * - width
   * - height
   * 
   * @param {string} name the name of the property
   * @return {VASTProperty} a {@link VASTProperty} object or null if not found
   */;
  _proto.getProperty = function getProperty(name) {
    for (var _iterator = _createForOfIteratorHelperLoose(this.properties), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (prop.getName() === name) {
        return prop;
      }
    }
    return null;
  }

  /**
   * @return {Resource} the {@link Resource} of the image
   */;
  _proto.getResource = function getResource() {
    return this.resource;
  };
  _proto.isValid = function isValid() {
    return (0, _CreativeUtils.isValidSize)(this.properties) && (!(0, _StringUtils.isNullOrEmpty)(this.altText) || this.resource) ? true : false;
  };
  return IconClickFallbackImage;
}(_XmlValidation2.XmlValidation);